module.exports = __webpack_public_path__ + "static/img/tabela.8b59244.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/antares-cgas/tabela.png
// module id = fWHg
// module chunks = 0